module.exports = __webpack_public_path__ + "img/maza.430c9a4b.png";